import React from "react";
import * as api from "./api";
import { timediaUrl } from "../config";
import { mtUserUrl } from "../config";
import * as Storage from "./Storage";
export const ROLE_ADMIN = "ROLE_ADMIN";
export const ROLE_CANDIDAT = "ROLE_CANDIDAT";
export const ROLE_REUNION_ENFANT = "ROLE_REUNION_ENFANT";

///////////////////////////////////////////////////////////////////////////////////////////////
export const urlTimediaSearch = timediaUrl + "/public/medias";

export const auth = {
	inscriptionUser(self, callback) {
		// fetch(`${mtUserUrl}/public/inscriptionUser`, {
		fetch(`${mtUserUrl}/public/inscriptionUser`, {
			...api.defaultParams,
			method: "POST",
			body: JSON.stringify({
				email: self.state.email.value,
				prenom: self.state.prenom.value,
				nom: self.state.nom.value,
				password: self.state.password.value,
				lieuNaissance: self.state.lieuNaissance.value,
				dateNaissance: self.state.dateNaissance.value,
				telMobile: self.state.telMobile.value
			})
		})
			.then(response => {
				if (response.status !== 200) {
					console.log("Error: " + response.status);
					return;
				}
				response.json().then(data => {
					callback(data);
				});
			})
			.catch(err => {
				console.log(err);
			});
	},

	changePassword(token, password, callback) {
		// fetch(`${timediaUrl}/public/userPasswordChange/${token}`, {
		fetch(`${mtUserUrl}/public/userPasswordChange/${token}`, {
			...api.defaultParams,
			method: "PUT",
			body: JSON.stringify({
				newPassword: password
			})
		})
			.then(response => {
				if (response.status !== 200) {
					console.log("Error: " + response.status);
					return;
				}
				response.json().then(data => {
					callback(data);
				});
			})
			.catch(err => {
				console.log(err);
			});
	},

	sendAuthLinkByMail(email, callback) {
		// fetch(`${mtUserUrl}/public/sendLinkUserPasswordForgot`, {
		fetch(`${mtUserUrl}/public/sendLinkUserPasswordForgot`, {
			...api.defaultParams,
			method: "PUT",
			body: JSON.stringify({
				email: email
			})
		})
			.then(response => {
				if (response.status !== 200) {
					console.log("Error: " + response.status);
					return;
				}
				response.json().then(data => {
					callback(data);
				});
			})
			.catch(err => {
				console.log(err);
			});
	},

	signout(callback) {
		Storage.removeUser();
		Storage.removeAuthorities();

		Storage.setAuthoritiesJson(JSON.stringify(["ROLE_PUBLIC"]));
		if (callback && typeof callback === "function") {
			callback();
		}
	},

	getUser() {
		var user = Storage.getUserParsed();
		return user;
	},

	isAuthenticated() {
		console.log(Storage.getAuthoritiesJson());
		console.log(Storage.getUserParsed());

		if (Storage.getAuthoritiesJson() === null) {
			Storage.setAuthoritiesJson(JSON.stringify(["ROLE_PUBLIC"]));
			window.location.reload();
		}
		if (JSON.stringify(Storage.getUserParsed()) === JSON.stringify({})) {
			console.log("oui");
			return false;
		} else {
			return true;
		}
	},

	userHaveAuthorities(authorities) {
		return (
			(this.isAuthenticated() && this.hasRoles(authorities)) ||
			this.hasRoles(["ROLE_ADMIN"])
		);
	},

	hasRoles(values) {
		var retour = false;
		var authorities = Storage.getAuthoritiesJson();
		if (authorities !== null) {
			values.forEach(function(value) {
				if (authorities.includes(value) || authorities.includes("ROLE_ADMIN")) {
					retour = true;
				}
			});
		}
		return retour;
	},

	updateAuthorities() {
		const user = Storage.getUserParsed();
		if (user !== null) {
			fetch(`${timediaUrl}/public/getAuthorities`, {
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json",
					Authorization: "Basic " + user.token
				},
				method: "PUT",
				body: window.location.href
			})
				.then(response => {
					if (response.status !== 200) {
						console.error("Error: " + response.status);
						return;
					}
					response.json().then(json => {
						var data = JSON.stringify(json);
						var authorities = new Array();
						json.data.forEach(function(authority) {
							authorities.push(authority.name);
						});
						Storage.setAuthoritiesJson(JSON.stringify(authorities));
					});
				})
				.catch(function(error) {});
		}
	},

	getAccessToken() {
		const user = Storage.getUserParsed();
		if (user === null) {
			return Promise.resolve(null);
		}

		// ⚠️ Ici on RETURN la Promise de fetch
		return fetch(
			`https://iam.timothee.fr/realms/timothee/protocol/openid-connect/token`,
			{
				headers: { "Content-Type": "application/x-www-form-urlencoded" },
				method: "POST",
				body: `grant_type=refresh_token&client_id=site-mitim-tmp&refresh_token=${user.refreshToken}`
			}
		)
			.then(response => {
				if (!response.ok) {
					throw new Error("Error: " + response.status);
				}
				return response.json(); //
			})
			.then(json => {
				return json.access_token; //
			});
	},

	authenticateByToken(token, callback) {
		fetch(`${mtUserUrl}/public/authByToken/${token}`, {
			...api.defaultParams,
			method: "GET"
		})
			.then(response => {
				if (response.status !== 200) {
					console.log("Error: " + response.status);
					return;
				}
				response.json().then(data => {
					callback(data);
				});
			})
			.catch(err => {
				console.log(err);
			});
	}
};
